import React from 'react'
import { Grid as GridBase, styled } from '@mui/material'
import { Dialog as DialogBase } from '@chilecompra/react-kit/components'

export const Dialog = styled(DialogBase)`
  & > div {
    box-sizing: border-box;
    max-width: 1064px;
    padding: 52px 108px 28px;
    box-shadow: 0 0 40px rgba(255, 255, 255, 0.6);
  }
`

export const GridContainer = styled(({ height, margin, maxWidth, padding, ...props }) => (
  <GridBase container {...props} />
))`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ height, margin, padding, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Link = styled('a')`
  color: ${props => props.theme.palette.brand.primary};

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
  }

  &:visited {
    color: ${props => props.theme.palette.brand.primary};
  }
`
export const ImageContainer = styled('div')`
  justify-content: center;
  align-items: center;
  margin: 0 auto 0 auto;
  width: fit-content;
`

export const Image = styled('img')`
  display: block;
  max-width: 176px;
  height: 208px;
`
export const Strong = styled('strong')``

export const DialogCustom = styled(DialogBase)`
  & > div {
    box-sizing: border-box;
    max-width: 877px !important;
    height: 650px;
    padding: 0 74px 0;
    box-shadow: 0 0 40px rgba(255, 255, 255, 0.6);
    border-radius: 16px;
    background-color: white;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`
